/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate>): BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate(), model);
        BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate>): BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate.newInstance(<BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
